import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-logo">
          <span className="logo-bracket">&lt;</span>KK<span className="logo-bracket"> /&gt;</span>
        </div>
        <p className="footer-copy">
          Designed & built by Krish Kumar · {new Date().getFullYear()}
        </p>
        <p className="footer-stack">
          Built with React · Hosted on Vercel
        </p>
      </div>
    </footer>
  );
}
